module.exports = __webpack_public_path__ + "static/media/logoSSF.170e5402.png";